<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :wrapClassName="wrapClassNameInfo()"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:5%;height: 90%;">
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          取消
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-form :form="form" id="functionModal">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规则名称">
            <a-input placeholder="请输入规则名称" v-decorator.trim="[ 'ruleName', validatorRules.ruleName]"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规则编码">
            <a-input placeholder="请输入规则编码" v-decorator.trim="[ 'ruleCode', validatorRules.ruleCode]"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发码机构">
            <a-select v-decorator.trim="[ 'ruleSystem', validatorRules.ruleSystem]">
              <a-select-option v-for="item in ruleSystem" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="参考标准1">
            <a-select default-value="1" v-decorator.trim="[ 'ruleCategory', validatorRules.ruleCategory]">
              <a-select-option v-for="item in ruleCategory" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类别">
            <a-select v-decorator.trim="[ 'ruleLabel', validatorRules.ruleLabel]">
              <a-select-option v-for="item in ruleLabel" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
            <a-select v-decorator.trim="[ 'status', validatorRules.status]">
              <a-select-option value="0">正常</a-select-option>
              <a-select-option value="1">停用</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序">
            <a-input placeholder="请输入排序" v-decorator.trim="[ 'ruleSort', validatorRules.ruleSort ]"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
            <a-textarea placeholder="请输入备注" :auto-size="{ minRows: 3, maxRows: 5 }" v-decorator.trim="[ 'remark', validatorRules.remark]"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="测试解析地址" v-if="title === '解析地址'">
            <a-input placeholder="请输入测试解析地址" v-decorator.trim="[ 'testAddress', validatorRules.testAddress]"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="解析地址" v-if="title === '解析地址'">
            <a-input placeholder="请输入解析地址" v-decorator.trim="[ 'targetAddress', validatorRules.targetAddress]"/>
          </a-form-item>
        </a-form>
      </a-spin>
      <function-tree-modal ref="functionTreeModal" @ok="functionTreeModalOk"></function-tree-modal>
    </a-modal>
  </div>
</template>

<script>
  import pick from 'lodash.pick'
  import { addCodeRule, editCodeRule, queryEnableDictItemsByCode } from '@/api/identifierCode/identifierCode'
  import {autoJumpNextInput} from "@/utils/util"
  import { mixinDevice } from '@/utils/mixin'
  export default {
    name: 'CodeRuleModal',
    mixins: [ mixinDevice ],
    props: {
      current: { type: Array, required: true }
    },
    data() {
      return {
        title:"操作",
        visible: false,
        model: {},
        enabledSwitch: true, //是否启用
        isReadOnly: false,
        jselectMultiple: {
          options: [
            { text: '编辑', value: '1' },
            { text: '审核', value: '2' },
            { text: '反审核', value: '7' },
            { text: '导出', value: '3' },
            { text: '启用禁用', value: '4' },
            { text: '打印', value: '5' },
            { text: '作废', value: '6' }
          ],
          value: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
          ruleName:{
            rules: [
              { required: true, message: '请输入规则名称！' }
            ]
          },
          ruleCode:{
            rules: [
              { required: true, message: '请输入规则编码！' }
            ]
          },
          ruleLabel:{
            rules: [
              { required: true, message: '请选择类别！' }
            ]
          },
          status:{
            rules: [
              { required: true, message: '请选择状态！' }
            ]
          }
        },
        // 下拉框数据
        ruleSystem: [], // 发码机构
        ruleCategory: [], // 参考标准
        ruleLabel: [] // 类别
      }
    },
    methods: {
      onChange(checked) {
        this.model.enabled = checked
      },
      add () {
        this.edit({});
        this.model.enabled = true
        this.enabledSwitch = true
      },
      edit (record) {
        console.log('这是嘛？')
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.enabled!=null){
          this.enabledSwitch = record.enabled?true:false;
        }
        if(this.model.uuid){
          this.jselectMultiple.value = record.pushBtn

          // 转换字符串与数字
        this.model.ruleLabel = this.model.ruleLabel.toString()

        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'ruleName', 'ruleCode', 'ruleSystem', 'ruleCategory', 'ruleLabel', 'status', 'remark', 'ruleSort' ))
          autoJumpNextInput('codeRuleModal')
        });
        } else {
          this.jselectMultiple.value = ''

          this.model = {
            ruleLabel: '3',
            status: '0',
          }
          this.$nextTick(() => {
            this.form.setFieldsValue(pick( this.model, 'ruleLabel', 'status' ))
            autoJumpNextInput('codeRuleModal')
          });
        }
        
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            formData.pushBtn = this.jselectMultiple.value
            let obj;
            if(!this.model.uuid){
              // 删除表单多余字段
              delete formData.enabled
              delete formData.pushBtn

              if ( this.current[0] === 'enterpriseRule' ) {
                // 企业规则
                formData.isStandard = 1
              } else {
                // 标准规则
                formData.isStandard = 0
              }

              obj = addCodeRule( formData );
            }else{
              obj=editCodeRule( formData );
            }
            obj.then((res)=>{
              if(res.code === 200){
                that.$emit('ok');
              }else{
                that.$message.warning(res.data.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateNumber(rule, value, callback){
        let params = {
          number: value,
          id: this.model.id?this.model.id:0
        };
        checkNumber(params).then((res)=>{
          if(res && res.code===200) {
            if(!res.data.status){
              callback();
            } else {
              callback("编号已经存在！");
            }
          } else {
            callback(res.data);
          }
        });
      },
      validateName(rule, value, callback){
        let params = {
          name: value,
          id: this.model.id?this.model.id:0
        };
        checkFunction(params).then((res)=>{
          if(res && res.code===200) {
            if(!res.data.status){
              callback();
            } else {
              callback("名称已经存在！");
            }
          } else {
            callback(res.data);
          }
        });
      },
      onSearchParentNumber() {
        this.$refs.functionTreeModal.edit(this.model.id);
        this.$refs.functionTreeModal.title = "选择上级编号";
        this.$refs.functionTreeModal.disableSubmit = false;
      },
      functionTreeModalOk(number, name) {
        this.form.setFieldsValue({'parentNumber': number, 'parentName': name})
      }
    },
    created() {
      // 获取发码机构下拉框
      queryEnableDictItemsByCode({code: 'send_code_org'})
      .then(res => {
        this.ruleSystem = res
      })
      // 获取参考标准下拉框
      queryEnableDictItemsByCode({code: 'Reference_Standards'})
      .then(res => {
        this.ruleCategory = res
      })
      // 获取类别单选框
      queryEnableDictItemsByCode({code: 'rule_code_type'})
      .then(res => {
        this.ruleLabel = res
      })
    }
  }
</script>